import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import {
  FaUserTie,
  FaGlobe,
  FaNetworkWired,
  FaHandsHelping,
} from "react-icons/fa";
import Aos from "aos";
import "./NedenBiz.css";

const NedenBiz = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const items = [
    {
      icon: <FaUserTie />,
      title: "Deneyimli Kadro",
      text: "20 yılı aşkın hukuki danışmanlık ve dava çözümleri deneyimi, kendini geliştiren, uzman ve dinamik avukat kadrosu ile yanınızdayız.",
      variant: "emerald",
    },
    {
      icon: <FaGlobe />,
      title: "Uluslararası Standartlar",
      text: "Hukuki çözümlerimizi, evrensel standartlara dayalı bir süreç yaklaşımıyla sunarak, uluslararası hukuk kurallarına hakimiyetimiz ile müvekkillerimize en iyiyi sağlıyoruz.",
      variant: "blue",
    },
    {
      icon: <FaNetworkWired />,
      title: "Global Hizmet Ağı",
      text: "Türkiye ve Avrupa ülkeleri başta olmak üzere dünya genelindeki müvekkillerimize geniş kapsamlı hukuki danışmanlık hizmetleri sunuyoruz.",
      variant: "indigo",
    },
    {
      icon: <FaHandsHelping />,
      title: "Müvekkil Odaklı Yaklaşım",
      text: "İhtiyaçlarınıza özel çözümler üretiyor, sizinle iş birliği yaparak hukuki konularda güvenilir destek sağlıyoruz.",
      variant: "amber",
    },
  ];

  return (
    <div className="nedenbiz-section">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="8">
            <h2
              className="nedenbiz-title"
              style={{ marginTop: !isMobile ? "2rem" : "1rem" }}
            >
              NEDEN BİZİ SEÇMELİSİNİZ?
            </h2>
          </Col>
        </Row>

        <Row className="mt-4 md:px-0 px-2">
          {items.map((item, idx) => (
            <Col md="3" sm="6" xs="12" key={idx} data-aos="fade-up">
              <div className={`nedenbiz-card nb-${item.variant}`}>
                <div className="nedenbiz-icon">{item.icon}</div>
                <h3 className="nedenbiz-card-title">{item.title}</h3>
                <p className="nedenbiz-text">{item.text}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default NedenBiz;
